export const formatSocialStat = (value) => {
  if (value == null || value === '') return '—'

  if (typeof value === 'string') return value

  const number = Number(value)
  if (!Number.isFinite(number)) return '—'

  if (number >= 1_000_000) {
    const scaled = number / 1_000_000
    const digits = number >= 10_000_000 ? 0 : 1
    return `${scaled.toFixed(digits).replace(/\.0$/, '')}M`
  }

  if (number >= 1_000) {
    const scaled = number / 1_000
    const digits = number >= 100_000 ? 0 : 1
    return `${scaled.toFixed(digits).replace(/\.0$/, '')}K`
  }

  return String(number)
}

export const SOCIAL_PLATFORMS = [
  { id: 'tiktok', label: 'tiktok' },
  { id: 'instagram', label: 'instagram' },
  { id: 'youtube', label: 'youtube' },
]
